import "../App.css";

export default function Resume() {
	return (<div className="content" style={{ height: "100vh" }}>
		<div className="image-bg"></div>

		<iframe title="Pia-Rey-resume" src="https://drive.google.com/file/d/1sa8_RJUM_WMwNNj8FGIJLdwS5rVbedze/preview" width="640" height="480" className="resume-embed"></iframe>
	</div >);
}